import * as React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  TextField,
  required,
  ArrayInput,
  SimpleFormIterator,
  FileInput,
  FileField,
  ReferenceInput,
  AutocompleteInput,
  FormDataConsumer,
} from 'react-admin';

import { BASE_URL } from '../../Constants';
import { getUser } from '../../Providers/index';

export const DocumentCommunitiesCreate = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextField source="Create Document" />
        <TextInput
          source="documentType"
          label="Document Type"
          defaultValue="communities"
          disabled
        />
        <ArrayInput source="array">
          <SimpleFormIterator>
            <FormDataConsumer>
              {({
                formData,
                scopedFormData, // The data for this item of the ArrayInput
                getSource,
                ...rest
              }) => {
                console.log(formData);
                return (
                  <>
                    <ReferenceInput
                      validate={[required()]}
                      source={getSource(`divisionId`)}
                      reference="divisions"
                      label="divisions"
                      sort={{ field: 'name', order: 'ASC' }}
                    >
                      <AutocompleteInput optionText="name" />
                    </ReferenceInput>
                    {scopedFormData
                      ? scopedFormData.divisionId && (
                          <CustomInput
                            formData={formData}
                            scopedFormData={scopedFormData}
                            getSource={getSource}
                          />
                        )
                      : null}
                  </>
                );
              }}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>
        <ArrayInput source="files" validate={[required()]}>
          <SimpleFormIterator>
            <TextInput source="title" label="Title" validate={[required()]} />
            <TextInput source="description" label="Description" validate={[required()]} />
            <FileInput
              source="location"
              labelSingle="Drop File"
              minSize={5}
              maxSize={10000000}
              validate={[required()]}
            >
              <FileField source="src" title="title" />
            </FileInput>
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Create>
  );
};

const CustomInput = (customProps) => {
  const [choices, setChoices] = React.useState([]);
  const [inputValue] = React.useState('');
  const { scopedFormData, getSource } = customProps;
  const [initialValue, setInitialValue] = React.useState('');
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    const check = async () => {
      const res = await getUser();
      const tokenId = res.Aa;
      const token = tokenId;
      const options = {
        headers: new Headers({
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        }),
      };
      const data = await fetch(
        `${BASE_URL}/divisionCommunities?divisionId=${scopedFormData.divisionId}&q=${inputValue}`,
        options
      );
      if (data.status === 200) {
        const choices = await data.json();
        if (choices.length === 0) {
          setInitialValue('No records');
        } else {
          setChoices(choices);
        }
      }
      setLoading(false);
    };
    check();
    return () => {
      setLoading(true);
      setInitialValue('');
      setChoices([]);
    };
  }, [scopedFormData.divisionId,inputValue]);
  return (
    <>
      <AutocompleteInput
        validate={[required()]}
        source={getSource(`communityId`)}
        choices={choices}
        options={{ label: 'community' }}
        // onInputValueChange={(inputValue) => {
        //   console.log(inputValue);
        //   setInputValue(inputValue);
        // }}
        inputValue={initialValue}
        loading={loading}
      />
    </>
  );
};
